import React, { Component } from "react";

import Toggle from "../Toggle";

import styles from "./styles.module.scss";

class CollapsibleMenu extends Component {
    static defaultProps = {
        defaultOpen: true,
    };

    constructor(props) {
        super(props);

        this.state = {
            isMenuOpen:
                this.props.value !== undefined
                    ? this.props.value
                    : props.defaultOpen && !props.isLocked,
        };
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.value !== undefined &&
            prevProps.value !== this.props.value
        ) {
            this.setState({ isMenuOpen: this.props.value });
        }
    }

    toggleClass = () => {
        !this.props.isLocked &&
            this.setState((prevState) => ({
                isMenuOpen: !prevState.isMenuOpen,
            }));
    };

    renderToggle = () => {
        const { value, onChange, dataTestId } = this.props;

        if (onChange) {
            return (
                <div className={styles.toggle}>
                    <Toggle
                        ariaLabel="acceptance"
                        value={value}
                        dataTestId={
                            dataTestId ? `open-${dataTestId}` : undefined
                        }
                        onChange={(e) => {
                            this.toggleClass();
                            onChange(e);
                        }}
                    />
                </div>
            );
        }

        return (
            <div
                className={styles.collapseBtn}
                data-testid={dataTestId ? `open-${dataTestId}` : undefined}
                onClick={this.toggleClass}
            />
        );
    };

    render() {
        const { title, children, dataTestId, allowsOverflow } = this.props;
        const { isMenuOpen } = this.state;

        let classes = [styles.collapsible];
        if (isMenuOpen) classes.push(styles.open);
        if (allowsOverflow) classes.push(styles.allowsOverflow);

        return (
            <div className={classes.join(" ")} data-testid={dataTestId}>
                <div className={styles.header}>
                    <span className={styles.title}>{title}</span>

                    {this.renderToggle()}
                </div>
                <div className={styles.content}>{children}</div>
            </div>
        );
    }
}

export default CollapsibleMenu;
